import React, { useState, useCallback, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Heading from "../../../../../../common/element/Heading/index.js";
import BtnLight from "../../../../../../common/element/Buttons/btnLight.js";
import Dropdown from "../../../../../../common/element/Dropdown/Dropdown.js";
import { setBreadcrumbs } from "../../../../../../redux/classes/breadcrumbsSlice.js";
import Button from "../../../../../../common/element/Buttons/index.js";
import ClientMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/ClientMultiSelectDropdown.js";
import RecipientMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/RecipientTypeMultiSelectDropdown.js";
import moment from "moment";
import { CustomReports } from "../../../../../../actions/Admin-Client/reports/ClientCustomReport.js";
import Dialog from "../../../../../../common/element/Dialog/Dialog.js";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";
import Input from "../../../../../../common/element/Input/Input.js";
import BtnPrimary from "../../../../../../common/element/Buttons/btnPrimary.js";
import logoPDF from "./LogoPDF.png";
import * as userActions from "../../../../../../actions/index";
import { ClientFavouriteReportsOrNot } from "../../../../../../actions/admin-provider/reports/ClientReportFavOrNot.js";
import ClientCheckListMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/ClientCheckListMultiSelectDropdown.js";
// import PieChart from "./ClientCompliaceCheckChart.js";
import { useLocation, useNavigate } from "react-router-dom";
import ClientCompliaceCheckChart from './ClientCompliaceCheckChart.js'
import ClientCompliaceCheckList from "./ClientCompliaceCheckList.js";
import useUnauthorizedHandler from "../../../../../../common/snippet/useUnauthorizedHandler.js";
import { CSVLink } from "react-csv";
import ThreeDotBouncing from "../../../../../../common/element/PageLoader/index.js";
import { Pagination } from "../../../../../../common/pagination/index.js";
import ReactPaginate from "react-paginate";
import DateMultiSelectDropdown from "../../../../../../common/MultiSelectFilter/DateMultiSelectDropdown.js";
import ProgressCircle from "./ProgressCircle.js";
import { GenerateClientCompChecklistReportFunction } from "../../../../../../actions/Admin/reports/GenerateClientCompChecklistReportFunction.js";
import ThreeDotLoader from "../../../../../../common/element/ButtonLoader/ThreeDotLoader";
import { notify } from "react-notify-toast";

const ClientsComplianceChecklist = () => {
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate()
    const { favReport, cstRep } = location.state || {};

    const handleUnauthorizedAccess = useUnauthorizedHandler();
    const storedData = JSON.parse(localStorage.getItem("LoginUserData"));
    const [unSaveDialogIsOpen, unSaveSetIsOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [removeDilaog, setRemoveDialog] = useState(false);
    const [custReportName, setCustReportName] = useState("")
    const [custSuccessMsg, setCustSuccessMsg] = useState(false);
    const [custErrMsg, setCustErrMsg] = useState("")
    const [openSuccessDialog, setOpenSuccessDialog] = useState(false)
    const [saveCustomRep, setSaveCustomRep] = useState(false)
    const [processedCsvData, setProcessedCsvData] = useState([])
    const [filtersort, setFiltersort] = useState();
    const [loadData, setLoadData] = useState(false);
    const [isGenerating, setIsGenerating] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [filterorder, setFilterOrder] = useState("desc");
    const [selectReport, setSelectReport] = useState(false);
    const [filterpage, setfilterpage] = useState(1);
    const [filterlimit, setfilterlimit] = useState(10);
    const [publishDate, setPublishDate] = useState("");
    const [renewalDate, setRenewalDate] = useState("")
    const [searchTerm, setsearchTerm] = useState("");
    const [recipientType, setRecipientType] = useState("")
    const [successText, setSuccessText] = useState("");
    const [pdfDownloadSuccessDialog, setPdfDownloadSuccessDialog] =
        useState(false);
    const [checkPdfLoad, setCheckPdfLoad] = useState(true);
    const [totalPages, setTotalPages] = useState(1);
    const [cheklistIds, setChecklistIds] = useState([])
    const [client_org_ids, setClient_org_ids] = useState([]);
    const [countData, setCountData] = useState(0);
    const [activeCount, setActiveCount] = useState({ active: 0, inactive: 0 });
    const [totalCheckListData, setTotalCheckListData] = useState({});
    const [overAllComplianceRate, setOverAllComplianceRate] = useState(0);
    const [functionId, setfunctionId] = useState("");
    const [date_range, setDate_range] = useState("");
    const [key, setKey] = useState("custom");
    const [dateMinMax, setDateMinMax] = useState({
        lowestDate: null,
        greatestDate: null,
    });
    const [refreshKey, setRefreshKey] = useState(0);//Add refresh key 
    let userType;
    let userId;
    if (storedData) {
        userId = storedData?.userName?.user_id;
        userType = storedData?.data?.role?.role_name

        // userType=storedData
    }
    const inputChangeHandler = (e) => {
        setCustReportName(e)
        setCustErrMsg("")
    };

    const CreateComplianceChecklistReport = useCallback(
        async () => {
            dispatch(
                userActions.CreateComplianceChecklistReport({
                    // contactTypeId,
                    searchTerm,
                    filterpage,
                    filterlimit,
                    filtersort,
                    filterorder,
                    client_org_ids,
                    date_range,
                    cheklistIds,
                    recipientType,
                    publishDate,
                    renewalDate
                    // Add Status here
                })
            ).then((response) => {
                if (response?.success === true) {
                    setCountData(response?.data.count);
                    const arrayData = response?.data.rows;
                    const totalCheckListData = response?.data.summary;
                    const OverAllComplianceRate = response?.data?.summary?.OverAllComplianceRate?.toFixed(2);
                    setTableData(arrayData);
                    setTotalCheckListData(totalCheckListData)
                    setOverAllComplianceRate(OverAllComplianceRate)
                    setLoadData(true);
                    const timestamps = arrayData.map((product) =>
                        new Date(product?.date_joined).getTime()
                    );
                    const lowestDate = new Date(Math.min(...timestamps));
                    const greatestDate = new Date(Math.max(...timestamps));
                    setDateMinMax({ lowestDate, greatestDate });
                    setTotalPages(Math.ceil(response?.data?.count / filterlimit));
                    const activeCount = arrayData.filter(item => item.status === 'Active').length;
                    const inactiveCount = arrayData.filter(item => item.status === 'Inactive').length;
                    setActiveCount({ active: activeCount, inactive: inactiveCount });
                } else if (response?.status === 401) {
                    handleUnauthorizedAccess();
                    setLoadData(true);
                } else {
                    setLoadData(true);
                }
            });
            // eslint-disable-next-line
        },
        [
            dispatch,
            searchTerm,
            filterpage,
            filterlimit,
            filtersort,
            filterorder,
            client_org_ids,
            date_range,
            cheklistIds,
            recipientType,
            publishDate,
            renewalDate
        ]
    );

    useEffect(() => {
        CreateComplianceChecklistReport();
    }, [
        searchTerm,
        filterpage,
        filterlimit,
        filtersort,
        filterorder,
        client_org_ids,
        date_range,
        cheklistIds,
        recipientType,
        publishDate,
        renewalDate,
        refreshKey, // added
    ]);

    const csvLinkRef = useRef(null);

    // Define the columns (headers) for the CSV export
    const csvHeaders = [
        { label: "Client name", key: "client_name" },
        { label: "Checklist name", key: "checklist_name" },
        { label: "Recipient", key: "recipient_type" },
        { label: "Documents no.", key: "document_count" },
        { label: "Completion rate", key: "compliance_rate" },
        { label: "Publish date", key: "date_joined" },
        { label: "Renewal date", key: "renewal_date" }
    ];

    // In ClientsComplianceChecklist.js, update the updateFilter function
    const updateFilter = (fieldName, value) => {
        if (fieldName === "client_org_ids") {
            const organisationIds = value && value.map(item => item.organisation_id);
            setClient_org_ids(organisationIds ? organisationIds : []);
        }
        else if (fieldName === "checklist_ids") {
            setChecklistIds(value)
        }
        else if (fieldName === "recipient_type") {
            setRecipientType(value ? value : "");
        }
        else if (fieldName === "search") {
            setsearchTerm(value);
        } else if (fieldName === "sort") {
            setFiltersort(value);
        } else if (fieldName === "order") {
            setFilterOrder(value);
        } else if (fieldName === "date_range") {
            setDate_range(value);
        }
        else if (fieldName === "publish_date_range") { // joined date is publish date
            setPublishDate(value);
            if (value === "") {
                setRefreshKey((k) => k + 1); // force refetch for All time
            }
        }
        else if (fieldName === "renewal_date_range") {
            setRenewalDate(value);
            if (value === "") {
                setRefreshKey((k) => k + 1); // force refetch for All time
            }
        }


        // Reset pagination to first page when any filter changes
        setfilterpage(1);
        setfilterlimit(10);
    };

    const generateClientCompChecklist = async () => {
        try {
            setIsGenerating(true);
            const apiData = {
                search: searchTerm,
                filterpage,
                filterlimit,
                filtersort,
                filterorder,
                client_org_ids,
                date_range,
                cheklistIds,
                recipientType,
                publishDate,
                renewalDate,
            };

            const response = await dispatch(
                GenerateClientCompChecklistReportFunction(apiData)
            );

            if (response?.status === 401) {
                handleUnauthorizedAccess();
                notify.show(
                    "Unable to generate report due to authorization error.",
                    "error",
                    3000
                );
                setLoadData(true);
                return;
            }

            if (response?.success) {
                setLoadData(true);
                notify.show(
                    "Compliance Checklist Summary report generated successfully",
                    "success",
                    3000
                );
            } else {
                setLoadData(true);
                notify.show(
                    response?.message ||
                    "Unable to generate report. Please try again.",
                    "error",
                    3000
                );
            }
        } catch (error) {
            console.error("❌ Error generating report:", error);
            notify.show(
                "Error generating report. Please try again.",
                "error",
                3000
            );
        } finally {
            setIsGenerating(false);
        }
    };


    // Pre-process CSV data to format date fields using Moment.js.

    function getBase64ImageFromUrl(url) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            // Enable cross-origin loading if necessary
            img.setAttribute("crossOrigin", "anonymous");
            img.onload = () => {
                const canvas = document.createElement("canvas");
                canvas.width = img.width;
                canvas.height = img.height;
                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0);
                const dataURL = canvas.toDataURL("image/png");
                resolve(dataURL);
            };
            img.onerror = (error) => reject(error);
            img.src = url;
        });
    }
    const handleExport = async (format) => {
        setSuccessText(format);
        try {
            // Wait for data from GetPDFAllData
            const allReportData = await GetPDFAllData();
            if (!allReportData) {
                setCheckPdfLoad(false);
                console.error("Failed to fetch report data.");
                return;
            }
            setCheckPdfLoad(false);
            if (format === "csv") {
                setProcessedCsvData(
                    allReportData?.rows?.map((item) => {
                        return csvHeaders.reduce((newItem, header) => {
                            let value = item[header.key];
                            if (
                                (header.key.toLowerCase().includes("creation_date") && value) ||
                                header.key.toLowerCase().includes("approval_date")
                            ) {
                                value = moment(value).format("DD/MM/YYYY");
                            }
                            newItem[header.key] = value ?? "-";
                            return newItem;
                        }, {});
                    })
                );
            } else if (format === "excel") {
                const headerRow = csvHeaders.map(header => header.label);
                const dataRows = allReportData?.rows.map((item) =>
                    csvHeaders.map((header) => {
                        const value = item[header.key];
                        return value;
                    })
                );

                // Combine header and data rows.
                const exportData = [headerRow, ...dataRows];

	                // Convert the AOA to a worksheet.
	                const ws = XLSX.utils.aoa_to_sheet(exportData);
	                headerRow.forEach((header, index) => {
	                    const cellRef = XLSX.utils.encode_cell({ r: 0, c: index });
	                    if (ws[cellRef]) {
	                        ws[cellRef].s = { font: { bold: true } };
	                    }
	                });

	                // Step 1: Set column widths for better readability in Excel/LibreOffice.
	                const widthByKey = {
	                    client_name: 24,
	                    checklist_name: 28,
	                    recipient_type: 16,
	                    document_count: 14,
	                    compliance_rate: 16,
	                    date_joined: 14,
	                    renewal_date: 14,
	                };
	                ws["!cols"] = csvHeaders.map((h) => ({
	                    wch: widthByKey[h.key] || Math.max(12, String(h.label || "").length + 2),
	                }));

	                // Step 2: Best-effort wrap text (depends on XLSX writer support).
	                const ref = ws["!ref"];
	                if (ref) {
	                    const range = XLSX.utils.decode_range(ref);
	                    for (let r = range.s.r; r <= range.e.r; r += 1) {
	                        for (let c = range.s.c; c <= range.e.c; c += 1) {
	                            const addr = XLSX.utils.encode_cell({ r, c });
	                            const cell = ws[addr];
	                            if (!cell) continue;
	                            cell.s = cell.s || {};
	                            cell.s.alignment = {
	                                ...(cell.s.alignment || {}),
	                                wrapText: true,
	                                vertical: "top",
	                            };
	                        }
	                    }
	                }

	                const wb = XLSX.utils.book_new();
	                XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

	                // Save the Excel file.
	                XLSX.writeFile(wb, "compliance_checklist_summary_report.xlsx", { cellStyles: true });
	            }
	            else if (format === "pdf") {
	                const doc = new jsPDF("l"); // Set to landscape mode
	                const today = moment().format("DD/MM/YYYY");

                // Set font and add date (top left)
                doc.setFontSize(12);
                doc.text(today, 14, 15);

                // Add title in center
                const title = "Compliance Checklist Summary";
                doc.setFontSize(16);
                const pageWidth = doc.internal.pageSize.getWidth();
                const titleWidth = doc.getTextWidth(title);
                const titleX = (pageWidth - titleWidth) / 2;
                doc.text(title, titleX, 15);

                // Convert PNG image to Base64
                const logoUrl = logoPDF;
                let logoData;
                try {
                    logoData = await getBase64ImageFromUrl(logoUrl);
                } catch (error) {
                    console.error("Error converting image to Base64", error);
                }

                // Add logo image at top right if available
                if (logoData) {
                    const imageWidth = 40; // Adjust dimensions as needed
                    const imageHeight = 10;
                    const marginRight = 15;
                    doc.addImage(
                        logoData,
                        "PNG",
                        pageWidth - imageWidth - marginRight,
                        10,
                        imageWidth,
                        imageHeight
                    );
                }

                // Prepare table headers and rows
                const tableColumn = [
                    "S. no",
                    "Client name",
                    "Checklist name",
                    "Recipient",
                    "Documents no.",
                    "Completion rate",
                    "Publish date",
                    "Renewal date"
                ];

                // to be continue...
                const tableRows = allReportData?.rows?.map((row, index) => [
                    index + 1,
                    row.client_name, // Assuming this is the client name from tableData
                    row.checklist_name, // Assuming this is the checklist name from tableData
                    row.recipient_type, // Assuming this corresponds to the recipient in tableData
                    row.document_count, // Assuming this corresponds to documents number in tableData
                    row.compliance_rate, // Assuming this corresponds to the completion rate in tableData
                    row.date_joined ? row.date_joined : "-", // Format the date joined
                    row.renewal_date ? row.renewal_date : "-", // Format the renewal date
                    // row.date_joined ? moment(row.date_joined).format("DD/MM/YYYY") : "-", // Format the date joined
                    // row.renewal_date ? moment(row.renewal_date).format("DD/MM/YYYY") : "-", // Format the renewal date
                ]);

                // Add table starting below the header
                doc.autoTable({
                    head: [tableColumn],
                    body: tableRows,
                    startY: 25,
                    styles: { fontSize: 9, overflow: "linebreak" },
                    headStyles: {
                        fillColor: "#E5F3FE",
                        textColor: "#464A53",
                        overflow: "linebreak",
                    },
                    bodyStyles: {
                        textColor: "#000000",
                        overflow: "linebreak",
                    },
                    columnStyles: {
                        0: { cellWidth: 12 },
                        1: { cellWidth: 45 },
                        2: { cellWidth: 70 },
                        3: { cellWidth: 34 },
                        4: { cellWidth: 26 },
                        5: { cellWidth: 30 },
                        6: { cellWidth: 30 },
                        7: { cellWidth: 30 },
                    },
                });

                // Save the PDF
                doc.save("compliance_checklist_summary_report.pdf");
            }





        } catch (error) {
            console.error("Error exporting data:", error);
        }




    }

    const handlePageChange = ({ selected }) => {
        setfilterpage(selected + 1);
    };

    useEffect(() => {
        dispatch(
            setBreadcrumbs([
                { label: "Reports", url: "/admin/reports", home: "/admin/client/dashboard" },
                { label: "Compliance Checklist Summary", url: "/admin/client/reports/compliance-checklist" },
            ])
        );
    }, [dispatch]);

    useEffect(() => {
        if (favReport) {
            setSelectReport(favReport.some((ele) => ele.report_type == "compliance-checklist"))
        }

        return () => {
            setCustReportName(""); // Reset state on cleanup (unmount or dependency change)
        };
    }, [favReport])
    // Make sure the client_org_ids is properly formatted for the API
    const formattedClientOrgIds = (client_org_ids && client_org_ids.length) &&
        client_org_ids.map(client => ({
            organisation_id: client.organisation_id,
            function_assignment_id: client.function_assignment_id
        }));

    // dispatch(
    //     userActions.CreateComplianceChecklistReport({
    //         searchTerm,
    //         filterpage,
    //         filterlimit,
    //         filtersort,
    //         filterorder,
    //         client_org_ids: formattedClientOrgIds?formattedClientOrgIds:[], // Use the formatted array
    //         date_range,
    //         cheklistIds,
    //         recipientType,
    //         publishDate,
    //         renewalDate
    //     })
    // )
    // Add this to your useEffect blocks
    useEffect(() => {
        // Get function ID for "client" function
        dispatch(
            userActions.GetAllFunctions()
        ).then((response) => {
            if (response?.success) {
                const clientFunction = response.data.find(func => func.function_name === "client");
                if (clientFunction) {
                    setfunctionId(clientFunction.function_id);
                }
            }
        });
    }, [dispatch]);

    const GetPDFAllData = async () => {
        setPdfDownloadSuccessDialog(true);
        try {
            const response = await dispatch(userActions.CreateComplianceChecklistReport({
                searchTerm,
                client_org_ids: formattedClientOrgIds ? formattedClientOrgIds : [], // Use the formatted array
                date_range,
                cheklistIds,
                recipientType,
                publishDate,
                renewalDate
            }
            ));
            if (response.success) {
                setPdfDownloadSuccessDialog(true);
                return response.data; // Return the response data
            } else if (response?.status === 401) {
                handleUnauthorizedAccess();
            }
        } catch (error) {
            console.error("Error fetching PDF data:", error);
            setPdfDownloadSuccessDialog(true);
        } finally {
            setPdfDownloadSuccessDialog(true);
        }
        return null; // Return null if the request is not successful
    };

    const closeDownloadSuccessPdf = () => {
        setPdfDownloadSuccessDialog(false);
        setTimeout(() => {
            setCheckPdfLoad(true);
        }, 1000);
    };

    useEffect(() => {
        if (processedCsvData.length > 0) {
            csvLinkRef.current.link.click();
        }
    }, [processedCsvData]); // Runs when processedCsvData updates

    const handleFavReports = (reportType, reportTitle, isFav) => {
        setSelectReport(!selectReport)
        const payload = {
            user_id: userId, // Dynamically passed userId
            report_type: reportType, // Dynamically passed reportType
            is_favourite: isFav,
            user_type: userType, // Dynamically passed userType
            report_dashboard: "client",
            report_title: reportTitle
        }

        dispatch(ClientFavouriteReportsOrNot(payload))
            .then((res) => {
                if (res.status) {
                    // Handle the success response here
                    // Optionally update UI or give feedback to the user
                    // For example, you can update a state variable to show the report is favorited
                } else {
                    // Handle non-successful status codes here
                    console.error('Failed to favorite report:', res.message || 'Unknown error');
                }
            })
            .catch((error) => {
                // Handle the error (e.g., network error, server error, etc.)
                console.error('Error favoriting report:', error);
                // Optionally show a user-friendly message
            });
    }

    useEffect(() => {
        if (cstRep) {

            setSaveCustomRep(cstRep.some((ele) => ele.report_type == "compliance-checklist"))
            if (cstRep.some((ele) => ele.report_type == "compliance-checklist")) {
                setCustSuccessMsg(true)
                const data = cstRep[0]?.apply_filters
                setfilterpage(data.page)
                setfilterlimit(data.limit)
                setFiltersort(data.sort)
                setFilterOrder(data.order)
                setClient_org_ids(data?.client_org_ids ? JSON.stringify(data?.client_org_ids) : [])
                setDate_range(data?.date_range ? data?.date_range : "")
                setChecklistIds(data?.checklist_ids ? JSON.stringify(data?.checklist_ids) : [])
                setRecipientType(data?.recipient_type ? data?.recipient_type : "")
                setPublishDate(data?.joined_date_range ? data?.joined_date_range : "")
                setRenewalDate(data?.renewal_date_range ? data?.renewal_date_range : "")

            }
        }
    }, [cstRep])
    const handleConfirm = () => {
        unSaveSetIsOpen(true);
    }
    const handleUpdateCustomRep = () => {
        setRemoveDialog(true);
    }
    const onDialogCloseRemove = () => {
        setRemoveDialog(false);

    };
    const onDialogCloseUnSave = () => {
        unSaveSetIsOpen(false);

    };
    const onCloseDetails = () => {
        setCustSuccessMsg(false)
        navigate(-1);
        setOpenSuccessDialog("")
    }
    const handleCustom = (reportType, reportTitle, isCustom, type) => {
        if (!saveCustomRep && !custReportName) {
            setCustErrMsg("Please enter custom report name")
            return
        }
        const basePayload = {
            is_custom: isCustom,
            user_id: userId,
            report_type: reportType,
            user_type: userType,
            report_dashboard: "client",
            custom_report_name: cstRep?.[0]?.custom_report_name ? cstRep?.[0]?.custom_report_name : custReportName,
            report_title: reportTitle,
            apply_filters: {

                limit: filterlimit,
                page: filterpage,
                sort: filtersort,
                order: filterorder,
                client_org_ids: client_org_ids ? JSON.stringify(client_org_ids) : [],
                date_range: date_range,
                checklist_ids: cheklistIds ? JSON.stringify(cheklistIds) : [],
                recipient_type: recipientType,
                joined_date_range: publishDate,
                renewal_date_range: renewalDate
            }
        };

        if (type == "update" || saveCustomRep) {
            basePayload.report_custom_id = cstRep?.[0]?.report_custom_id;
        }

        const payload = basePayload



        dispatch(CustomReports(payload))
            .then((res) => {
                if (res.status) {
                    // Handle the success response here
                    if (type == "createOrDelete") {
                        setSaveCustomRep(!saveCustomRep)
                        setCustReportName("")
                        setOpenSuccessDialog(true)
                        // navigate( {
                        //   state: { favReport }
                        // });
                        //here i want to upload empty navigation data where i want to empty of cstRep data
                        unSaveSetIsOpen(false);
                    } else if (type == "update") {
                        setSaveCustomRep(true)
                        setRemoveDialog(false)
                        setOpenSuccessDialog(true)
                    }

                } else {
                    // Handle non-successful status codes here
                    console.error('Failed to favorite report:', res.message || 'Unknown error');
                }
            })
            .catch((error) => {
                // Handle the error (e.g., network error, server error, etc.)
                console.error('Error favoriting report:', error);
                // Optionally show a user-friendly message
            });
    }
    return (
        <React.Fragment>

            <div className="flex justify-between mb-5 border-b border-gray-200 pb-5">
                <Heading>Compliance Checklist Summary</Heading>
                <div className="flex gap-3">
                    {/* 🟦 Generate Button */}
                    <button
                        onClick={generateClientCompChecklist}
                        disabled={isGenerating}
                        className="bg-[#5786CC] text-white text-xs px-3 py-1 rounded-md hover:bg-[#3f6ab4] transition ml-2 min-w-[94px] flex items-center justify-center disabled:opacity-60 disabled:cursor-not-allowed"
                    >
                        {isGenerating ? <ThreeDotLoader /> : "Generate"}
                    </button>
                    {/* <BtnLight
                        className="h-10 w-10 flex items-center justify-center gap-2 text-12">
                        {selectReport ?
                            (<svg
                                onClick={() => handleFavReports("compliance-checklist", "Clients Compliance Checklist", false)}
                                width="21"
                                height="21"
                                viewBox="0 0 21 21"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <g clipPath="url(#clip0_15736_74961)">
                                    <path
                                        d="M9.87232 2.41075C10.0431 2.0001 10.6248 2.0001 10.7956 2.41075L12.8617 7.37822C12.9337 7.55134 13.0965 7.66963 13.2834 7.68461L18.6462 8.11454C19.0896 8.15009 19.2693 8.70334 18.9316 8.99267L14.8457 12.4927C14.7033 12.6147 14.6411 12.806 14.6846 12.9884L15.9329 18.2216C16.0361 18.6542 15.5655 18.9962 15.1859 18.7643L10.5946 15.96C10.4346 15.8622 10.2334 15.8622 10.0734 15.96L5.48204 18.7643C5.10249 18.9962 4.63187 18.6542 4.73506 18.2216L5.98337 12.9884C6.02687 12.806 5.96469 12.6147 5.82229 12.4927L1.7364 8.99267C1.39863 8.70334 1.57839 8.15009 2.02172 8.11454L7.38453 7.68461C7.57142 7.66963 7.73423 7.55134 7.80623 7.37822L9.87232 2.41075Z"
                                        fill="#FDB022"
                                    />
                                </g>
                                <defs>
                                    <clipPath id="clip0_15736_74961">
                                        <rect
                                            width="20"
                                            height="20"
                                            fill="white"
                                            transform="translate(0.333984 0.800781)"
                                        />
                                    </clipPath>
                                </defs>
                            </svg>)
                            :
                            (
                                <svg onClick={() => handleFavReports("compliance-checklist", "Clients Compliance Checklist", true)} width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.40156 2.8778C9.59363 2.48869 9.68967 2.29413 9.82004 2.23197C9.93347 2.17789 10.0653 2.17789 10.1787 2.23197C10.3091 2.29413 10.4051 2.48869 10.5972 2.8778L12.4194 6.56944C12.4761 6.68432 12.5045 6.74176 12.5459 6.78635C12.5826 6.82584 12.6266 6.85783 12.6754 6.88056C12.7306 6.90623 12.794 6.91549 12.9208 6.93402L16.9968 7.5298C17.4261 7.59253 17.6407 7.6239 17.74 7.72874C17.8264 7.81995 17.8671 7.94529 17.8506 8.06985C17.8317 8.21302 17.6763 8.36436 17.3656 8.66702L14.4172 11.5387C14.3253 11.6282 14.2794 11.673 14.2497 11.7263C14.2235 11.7734 14.2066 11.8252 14.2001 11.8788C14.1928 11.9393 14.2036 12.0025 14.2253 12.129L14.921 16.1851C14.9944 16.6129 15.031 16.8269 14.9621 16.9538C14.9021 17.0642 14.7955 17.1417 14.6719 17.1646C14.5299 17.1909 14.3378 17.0899 13.9536 16.8879L10.3097 14.9716C10.1961 14.9119 10.1394 14.882 10.0796 14.8703C10.0266 14.8599 9.97213 14.8599 9.91918 14.8703C9.85937 14.882 9.8026 14.9119 9.68906 14.9716L6.04512 16.8879C5.66095 17.0899 5.46886 17.1909 5.32683 17.1646C5.20325 17.1417 5.09662 17.0642 5.03663 16.9538C4.96768 16.8269 5.00437 16.6129 5.07774 16.1851L5.77342 12.129C5.79511 12.0025 5.80595 11.9393 5.79862 11.8788C5.79212 11.8252 5.77528 11.7734 5.74902 11.7263C5.71937 11.673 5.67341 11.6282 5.5815 11.5387L2.63315 8.66702C2.3224 8.36436 2.16703 8.21302 2.14812 8.06985C2.13167 7.94529 2.17231 7.81995 2.25872 7.72874C2.35804 7.6239 2.57266 7.59253 3.00189 7.5298L7.07794 6.93402C7.2047 6.91549 7.26808 6.90623 7.32328 6.88056C7.37215 6.85783 7.41615 6.82584 7.45284 6.78635C7.49427 6.74176 7.52262 6.68432 7.57933 6.56944L9.40156 2.8778Z" stroke="#344054" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                            )

                        }

                    </BtnLight> */}
                    {/* <BtnLight onClick={handleConfirm} className="h-10 w-40 flex items-center justify-center gap-2 text-12">
                        {saveCustomRep ? "Remove custom report" : "Save as custom report"}
                    </BtnLight>
                    {saveCustomRep && (
                        <BtnLight onClick={handleUpdateCustomRep} className="h-10 w-40 flex items-center justify-center gap-2 text-12">
                            {saveCustomRep && "Update custom report"}
                        </BtnLight>
                    )
                    } */}


                    <div className="export-dropdow">
                        <Dropdown title="Export" className="dropdown-btn">
                            <Dropdown.Item eventKey="a" onClick={() => handleExport('csv')} className="text-gray-900 font font-medium">CSV</Dropdown.Item>
                            <Dropdown.Item eventKey="b" onClick={() => handleExport('excel')} className="text-gray-900 font font-medium">Excel</Dropdown.Item>
                            <Dropdown.Item eventKey="c" onClick={() => handleExport('pdf')} className="text-gray-900 font font-medium">PDF</Dropdown.Item>

                        </Dropdown>
                        {processedCsvData?.length > 0 && (
                            <CSVLink
                                data={processedCsvData}
                                headers={csvHeaders}
                                filename="compliance_checklist_summary_report.csv"
                                className="hidden"
                                ref={csvLinkRef}
                                target="_blank"
                            />
                        )}
                    </div>
                </div>
            </div>
            <div className="flex justify-between bg-gray-50 rounded-xl py-3 px-4">
                {/* <div className="flex gap-5">
                    <div className="w-64"><Label className="mb-1 block">Date Range</Label>
                        <Input className="h-9 w-full" />
                    </div>
                    <div className="w-64"><Label className="mb-1 block">Client</Label>
                        <Select className="select-options" placeholder="All" />
                    </div>
                    <div className="w-64"><Label className="mb-1 block">Status</Label>
                        <Select className="select-options hide-seacrh-icon" placeholder="All" />
                    </div>
                </div> */}

                <div className="flex gap-1 cstm-dropdown">
                    <div>
                        <ClientMultiSelectDropdown
                            title='Client'
                            updateFilter={updateFilter}
                            client_org_ids={client_org_ids}
                            functionId={functionId}
                        />
                    </div>
                    <div>

                        <ClientCheckListMultiSelectDropdown
                            title="Checklist"
                            updateFilter={updateFilter}
                            client_org_ids={client_org_ids}
                        />
                    </div>
                    <div>
                        <RecipientMultiSelectDropdown
                            title='Recipient'
                            updateFilter={updateFilter}
                        />

                    </div>
                    <div>
                        <DateMultiSelectDropdown
                            title="Publish date"
                            type="publish_date_range"
                            setKey={setKey}
                            dateMinMax={dateMinMax.creation_date_range}
                            updateFilter={updateFilter}
                        />
                    </div>
                    <div>
                        <DateMultiSelectDropdown
                            title="Renewal date"
                            type="renewal_date_range"
                            setKey={setKey}
                            dateMinMax={dateMinMax.creation_date_range}
                            updateFilter={updateFilter}
                        />
                    </div>
                    {/* <div>
                        <ClientMultiSelectDropdown />
                    </div> */}
                </div>
                {/* <div className="flex gap-5">
                    <Button className="text-gray-600 text-xs font-semibold hover:text-gray-900">Clear All</Button>
                    <Button className="text-blue-700 text-xs font-semibold hover:text-blue-900">Update</Button>
                </div> */}
            </div>

            <div className="flex border items-center justify-center border-gray-100 rounded-xl p-6 mt-0" style={{ gap: '50px' }}>
                <ClientCompliaceCheckChart totalCheckListData={totalCheckListData} />
                {/* <PieChart /> */}
                <ProgressCircle percentage={overAllComplianceRate} />
            </div>


            <ClientCompliaceCheckList tableData={tableData} />
            {/* <ClientOverviewList /> */}
            {/* <div className="flex border border-gray-100 rounded-xl p-6 mt-5 gap-6">
            
            </div> */}
            {!loadData && (
                <div>
                    <ThreeDotBouncing />
                </div>
            )}

            {loadData && (
                <div className="flex justify-between mt-3">
                    <Pagination
                        totalCount={countData || 0}
                        pageNumber={filterpage}
                        displayPage={tableData?.length}
                        UpdatePageLimit={setfilterlimit}
                        UpdatePage={setfilterpage}
                    />
                    {countData > 0 && (
                        <ReactPaginate
                            className="flex justify-content-end p-2 align-items-center pagination-wrap"
                            previousLabel={"Prev"}
                            nextLabel={"Next"}
                            breakLabel={"..."}
                            breakClassName={"break-me"}
                            pageCount={totalPages}
                            marginPagesDisplayed={2}
                            pageRangeDisplayed={5}
                            onPageChange={handlePageChange}
                            containerClassName={"pagination"}
                            activeClassName={"active"}
                            previousLinkClassName={"prev-link"}
                            nextLinkClassName={"page-link"}
                            breakLinkClassName={"prev-link"}
                            previousClassname={"px-4 rounded-md bg-blue-700 text-white"}
                            nextClassname={"px-4 rounded-md bg-blue-700 text-white"}
                            pageLinkClassName={"px-4 rounded-md"}
                            activeLinkClassName={"w-9 h-9 bg-blue-700 text-white"}
                            disabledClassName={"px-5 opacity-50 cursor-not-allowed"}
                            renderOnZeroPageCount={null}
                            forcePage={filterpage - 1}
                        />
                    )}
                </div>
            )}
            <Dialog
                isOpen={pdfDownloadSuccessDialog}
                onClose={closeDownloadSuccessPdf}
                onRequestClose={closeDownloadSuccessPdf}
                bodyOpenClassName="overflow-hidden"
                className="customAlert"
            >
                <div className="px-6 pt-6">
                    {!checkPdfLoad && (
                        <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
                            <svg
                                width="49"
                                height="49"
                                viewBox="0 0 49 49"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    x="0.894531"
                                    y="0.585938"
                                    width="48"
                                    height="48"
                                    rx="24"
                                    fill="#D1FADF"
                                />
                                <path
                                    d="M26.8945 14.8555V18.986C26.8945 19.5461 26.8945 19.8261 27.0035 20.04C27.0994 20.2282 27.2524 20.3811 27.4405 20.477C27.6545 20.586 27.9345 20.586 28.4945 20.586H32.6251M28.8945 25.5859H20.8945M28.8945 29.5859H20.8945M22.8945 21.5859H20.8945M26.8945 14.5859H21.6945C20.0144 14.5859 19.1743 14.5859 18.5326 14.9129C17.9681 15.2005 17.5091 15.6595 17.2215 16.224C16.8945 16.8657 16.8945 17.7058 16.8945 19.3859V29.7859C16.8945 31.4661 16.8945 32.3062 17.2215 32.9479C17.5091 33.5124 17.9681 33.9713 18.5326 34.259C19.1743 34.5859 20.0144 34.5859 21.6945 34.5859H28.0945C29.7747 34.5859 30.6148 34.5859 31.2565 34.259C31.821 33.9713 32.2799 33.5124 32.5676 32.9479C32.8945 32.3062 32.8945 31.4661 32.8945 29.7859V20.5859L26.8945 14.5859Z"
                                    stroke="black"
                                    stroke-width="2"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                />
                            </svg>
                        </span>
                    )}
                    {checkPdfLoad && (
                        <div>
                            <ThreeDotBouncing />
                        </div>
                    )}
                    <p className="text-base text-gray-900 font-semibold text-center mt-4">
                        {checkPdfLoad
                            ? `${successText.charAt(0).toUpperCase() + successText.slice(1)
                            } downloading..`
                            : `${successText.charAt(0).toUpperCase() + successText.slice(1)
                            } downloaded successfully!`}
                    </p>
                </div>
                <div className="mt-8 flex justify-between pb-6 px-6">
                    <BtnLight onClick={() => closeDownloadSuccessPdf()}>Close</BtnLight>
                </div>
            </Dialog>
            {/* Dialogs for Custom reports */}
            <Dialog
                isOpen={unSaveDialogIsOpen}
                onClose={onDialogCloseUnSave}
                onRequestClose={onDialogCloseUnSave}
                bodyOpenClassName="overflow-hidden"
                className="customAlert"
            >
                <div className="px-6 pt-6">
                    <span className="w-12 h-12 rounded-full m-auto bg-warning-100 flex items-center justify-center">
                        <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M7.5 3.5v3.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.26 8.5 8.54 8.5 9.1 8.5h6.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054V4.5m0 17v-6.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.109-.494-.109-1.054-.109H9.1c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7.5 14.26 7.5 14.54 7.5 15.1v6.4m14-11.675V16.7c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327H8.3c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3.5 19.22 3.5 18.38 3.5 16.7V8.3c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.78 3.5 6.62 3.5 8.3 3.5h6.874c.49 0 .734 0 .965.055.204.05.399.13.578.24.201.123.374.296.72.642l3.126 3.126c.346.346.519.519.642.72.11.18.19.374.24.579.055.23.055.474.055.963z"
                                stroke="#000"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>
                    <h4 className="text-base text-gray-900 font-semibold text-center mt-4">
                        {saveCustomRep ? "Are you removing this custom report" : "Are you saving the custom report?"}

                    </h4>
                    {!saveCustomRep && (

                        <div style={{ marginTop: "10px" }}>
                            <Input
                                className="h-9 w-full"
                                placeholder="Type here"
                                value={custReportName}
                                name="message"
                                inputchangehandler={(e) => inputChangeHandler(e)}
                            />
                            {custErrMsg && (
                                <p className="text-xs text-red-600 mt-2">
                                    {custErrMsg}
                                </p>
                            )}
                        </div>
                    )}
                </div>

                <div className="mt-8 flex justify-between pb-6 px-6">
                    <BtnLight onClick={() => onDialogCloseUnSave()} className="mr-1.5">
                        Cancel
                    </BtnLight>
                    <BtnPrimary className="ml-1.5" onClick={() => handleCustom("compliance-checklist", "Compliance Checklist", saveCustomRep ? false : true, "createOrDelete")}>
                        Confirm
                    </BtnPrimary>
                </div>
            </Dialog>
            <Dialog
                isOpen={removeDilaog}
                onClose={onDialogCloseRemove}
                onRequestClose={onDialogCloseRemove}
                bodyOpenClassName="overflow-hidden"
                className="customAlert"
            >
                <div className="px-6 pt-6">
                    <span className="w-12 h-12 rounded-full m-auto bg-warning-100 flex items-center justify-center">
                        <svg
                            width="25"
                            height="25"
                            viewBox="0 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M7.5 3.5v3.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437C8.26 8.5 8.54 8.5 9.1 8.5h6.8c.56 0 .84 0 1.054-.109a1 1 0 0 0 .437-.437c.109-.214.109-.494.109-1.054V4.5m0 17v-6.4c0-.56 0-.84-.109-1.054a1 1 0 0 0-.437-.437c-.214-.109-.494-.109-1.054-.109H9.1c-.56 0-.84 0-1.054.109a1 1 0 0 0-.437.437C7.5 14.26 7.5 14.54 7.5 15.1v6.4m14-11.675V16.7c0 1.68 0 2.52-.327 3.162a3 3 0 0 1-1.311 1.311c-.642.327-1.482.327-3.162.327H8.3c-1.68 0-2.52 0-3.162-.327a3 3 0 0 1-1.311-1.311C3.5 19.22 3.5 18.38 3.5 16.7V8.3c0-1.68 0-2.52.327-3.162a3 3 0 0 1 1.311-1.311C5.78 3.5 6.62 3.5 8.3 3.5h6.874c.49 0 .734 0 .965.055.204.05.399.13.578.24.201.123.374.296.72.642l3.126 3.126c.346.346.519.519.642.72.11.18.19.374.24.579.055.23.055.474.055.963z"
                                stroke="#000"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </span>
                    <h4 className="text-base text-gray-900 font-semibold text-center mt-4">
                        {saveCustomRep && "Are you updating this custom report"}
                    </h4>
                </div>

                <div className="mt-8 flex justify-between pb-6 px-6">
                    <BtnLight onClick={() => onDialogCloseRemove()} className="mr-1.5">
                        Cancel
                    </BtnLight>
                    <BtnPrimary className="ml-1.5" onClick={() => handleCustom("clients-overview", "Clients Overview", true, "update")}>
                        Confirm
                    </BtnPrimary>
                </div>
            </Dialog>
            <Dialog
                isOpen={openSuccessDialog}
                onClose={onCloseDetails}
                onRequestClose={onCloseDetails}
                bodyOpenClassName="overflow-hidden"
                className="customAlert"
            >
                <div className="px-6 pt-6">
                    <span className="w-12 h-12 rounded-full m-auto bg-success-100 flex items-center justify-center">
                        <svg
                            width="25"
                            height="24"
                            viewBox="0 0 25 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M14.5 2.27V6.4c0 .56 0 .84.109 1.054a1 1 0 0 0 .437.437c.214.11.494.11 1.054.11h4.13M9.5 16l2 2 4.5-4.5M14.5 2H9.3c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C4.5 4.28 4.5 5.12 4.5 6.8v10.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C6.78 22 7.62 22 9.3 22h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311c.327-.642.327-1.482.327-3.162V8l-6-6z"
                                stroke="#344054"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            />
                        </svg>
                    </span>
                    <p className="text-base text-gray-900 font-semibold text-center mt-4">

                        {`Custom reports ${custSuccessMsg ? "updated" : "saved"}  successfully!`}
                    </p>
                </div>
                <div className="mt-8 flex justify-between pb-6 px-6">
                    <BtnPrimary onClick={onCloseDetails}>Close</BtnPrimary>
                </div>
            </Dialog>
        </React.Fragment>
    )
}


export default ClientsComplianceChecklist
